<template>
  <table class="d-table">
    <thead>
    <tr>
      <th>{{ title }}</th>
      <th>Skemalagte timer</th>
      <th>Berørte timer</th>
      <th>Vikar</th>
      <th>Medlærer, ingen vikar</th>
      <th>Aflyst</th>
      <th>Ude af huset</th>
      <th>Ikke dækket</th>
      <th>% af tiden med vikar</th>
      <th>% af berørte timer med vikar</th>
      <th>% med vikarnoter</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="row in rows" :key="row.name" :class="{'d-table__total': row.isTotal}">
      <td>{{ row.name }}</td>
      <td>{{ formatHours(row.totalMinutes) }}</td>
      <td>{{ formatHours(row.affectedMinutes) }}</td>
      <td>{{ formatHours(row.substitute) }}</td>
      <td>{{ formatHours(row.coTeacher) }}</td>
      <td>{{ formatHours(row.canceled) }}</td>
      <td>{{ formatHours(row.away) }}</td>
      <td>{{ formatHours(row.uncovered) }}</td>
      <td>{{ formatPercent(row.substitute, row.totalMinutes) }}</td>
      <td>{{ formatPercent(row.substitute, row.affectedMinutes) }}</td>
      <td>{{ formatPercent(row.lessonsWithNotes, row.lessonsWithAbsence) }}</td>
    </tr>
    <tr v-if="rows.length < 1">
      <td colspan="11" class="text-center">Ingen data i perioden</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    rows: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatHours (minutes) {
      return (minutes / 60).toFixed(1).replace('.', ',')
    },
    formatPercent (part, total) {
      if (!total) {
        return '-'
      }
      return Math.round(part / total * 100) + ' %'
    }
  }
}
</script>

<style scoped>
.d-table {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-collapse: collapse;
  background: #fff;
  margin-bottom: 2rem;
}

.d-table thead {
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  font-size: 11px;
  border-bottom: 1px solid #e2e8f0;
}

.d-table th,
.d-table td {
  padding: 0.5rem 1rem;
  text-align: right;
}

.d-table th:first-child,
.d-table td:first-child {
  text-align: left;
  width: 200px;
}

.d-table tbody tr {
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr:nth-child(even) {
  background: #f9fafb;
}

.d-table tbody tr:hover {
  background: aliceblue;
}

.d-table__total {
  font-weight: bold;
}

.text-center {
  text-align: center !important;
  color: #8898aa;
}
</style>



// WEBPACK FOOTER //
// SchoolDataCoverageTable.vue?3dc791b4